import { plural } from '@cian/utils';
import { EFloors } from '../../../../../types/buildersProjects';
import { sortListValue } from '../../../utils/sortListValues';

const FLOORS_ENUMS_TO_STRING = {
  [EFloors.One]: '1',
  [EFloors.Two]: '2',
  [EFloors.ThreeAndMore]: '3+',
};

const FLOORS_ENUMS_TO_NUMBER = {
  [EFloors.One]: 1,
  [EFloors.Two]: 2,
  /** 5 - чтобы корректно сработала функция plural и вывела последнюю форму слову */
  [EFloors.ThreeAndMore]: 5,
};

export const getFloorsLabel = (floors: EFloors[]): string | undefined => {
  if (!floors.length) {
    return;
  }

  if (floors.length === Object.keys(FLOORS_ENUMS_TO_STRING).length) {
    const first = FLOORS_ENUMS_TO_STRING[EFloors.One];
    const last = FLOORS_ENUMS_TO_STRING[EFloors.ThreeAndMore];

    return `${first}-${last} этажей`;
  }

  const sortingFloors = sortListValue(floors, Object.keys(FLOORS_ENUMS_TO_STRING));

  return sortingFloors
    .map((floor: EFloors, index: number) => {
      const floorNum = FLOORS_ENUMS_TO_NUMBER[floor];
      const floorStr = FLOORS_ENUMS_TO_STRING[floor];
      const isLast = index === floors.length - 1;

      return isLast ? `${floorStr} ${plural(floorNum, ['этаж', 'этажа', 'этажей'])}` : floorStr;
    })
    .join(', ');
};
